import { render, staticRenderFns } from "./NirDataUpdateEscalations.vue?vue&type=template&id=366f7f9b&scoped=true&"
import script from "./NirDataUpdateEscalations.vue?vue&type=script&lang=js&"
export * from "./NirDataUpdateEscalations.vue?vue&type=script&lang=js&"
import style0 from "./NirDataUpdateEscalations.vue?vue&type=style&index=0&id=366f7f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f7f9b",
  null
  
)

export default component.exports